import { Register } from "@/ui/vue-components/components";
import { defineCustomElement } from "vue";
import VoucherContabilCe from "./voucher/VoucherContabil.ce.vue";

const register: Register = {
  register() {
    customElements.get("vc-voucher-contabil") ||
      customElements.define(
        "vc-voucher-contabil",
        defineCustomElement(VoucherContabilCe)
      );
  }
};

export default register;
